import { usePresenceBroadcast } from '../../hooks/usePresenceBroadcast';
import { useActivityHeartbeat } from '../../hooks/useActivityHeartbeat';

/**
 * Composant sans rendu — monte la présence Realtime + le heartbeat d'activité.
 * À placer dans MainLayout, une seule fois.
 */
export function PresenceBroadcast() {
  usePresenceBroadcast();
  useActivityHeartbeat();
  return null;
}
